import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import general_45toggle_45global from "/app/middleware/general-toggle.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  general_45toggle_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.js"),
  "belajar-wajib": () => import("/app/middleware/belajar-wajib.js"),
  course: () => import("/app/middleware/course.js"),
  ecosystem: () => import("/app/middleware/ecosystem.js"),
  "orientasi-pppk": () => import("/app/middleware/orientasi-pppk.js"),
  "portal-pembelajaran": () => import("/app/middleware/portal-pembelajaran.js"),
  swajar: () => import("/app/middleware/swajar.js"),
  "user-data": () => import("/app/middleware/user-data.js")
}